"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavItem = function NavItem(_ref) {
  var children = _ref.children,
      to = _ref.to,
      color = _ref.color,
      fontWeight = _ref.fontWeight,
      mx = _ref.mx,
      my = _ref.my,
      px = _ref.px,
      py = _ref.py;
  var useStyle = (0, _styles.makeStyles)({
    root: {
      padding: "".concat(py || 10, "px ").concat(px || 15, "px"),
      margin: "".concat(my || 0, "px ").concat(mx || 5, "px"),
      textDecoration: 'none',
      color: color || '#fff',
      fontWeight: fontWeight || 500,
      transition: '.3s'
    }
  });

  var _useStyle = useStyle(),
      root = _useStyle.root;

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to || '/',
    className: root
  }, children);
};

var _default = NavItem;
exports["default"] = _default;